export const SCREEN_RESIZE = "SCREEN_RESIZE"

export const screenResize = (width) => {
    return {
        type: SCREEN_RESIZE,
        payload: { screenWidth: width }
    };
}